import { QueryClient } from '@tanstack/react-query';
import { isApiError } from './api';

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        // erros 4xx são definitivos; só repete falha de rede/5xx
        retry: (count, err) => (isApiError(err) && err.statusCode >= 400 && err.statusCode < 500 ? false : count < 2),
      },
    },
  });
}
